import React from 'react';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import {useEffect, useState } from "react";
import ImageUploading from 'react-images-uploading';
import { useParams } from "react-router";
import { createProgram } from '../../Service';
import { useSelector} from 'react-redux';
import Swal from 'sweetalert2';

export default function CreateProgramming(){
const [date, setDate] = useState(new Date());
const [startTime, setStartTime] = useState(new Date());
const [endTime, setEndTime] = useState(new Date());
const [images, setImages] = React.useState([]);
const maxNumber = 69;

  // const onChange = (imageList, addUpdateIndex) => {
  //   // data for submit
  //   console.log(imageList, addUpdateIndex);
  //   setImages(imageList);
  // };

  // create programming newcode
  let loggedUser = useSelector(store => store.user['user']);
  let user_id = '';
  if(loggedUser) {
     user_id = loggedUser.id;
  }
  
  const { id } = useParams();
  const event_id  = id;
  const [formErrors, setFormErrors] = useState({});
  const initialValues = { created_by:user_id, fair: event_id, title: "", date: "", start_time: "", end_time:"", description: "", zoom_link: "", type: "", cover_image: ""};
  const [formValues, setFormValues] = useState(initialValues);


  const onChange = (imageList, addUpdateIndex) => {
    // data for submit
    //console.log(imageList, addUpdateIndex);
    setImages(imageList);
    const field1='cover_image';
    setFormValues(prevState => ({
        ...prevState,
        [field1]:  imageList[0]['file']
    }));
    
};

  const handleChange = (e) => {
    //console.log('log 42', e.target.value);
    const value=e.target.value;
    const field=e.target.name;
    setFormValues(prevState => ({
        ...prevState,
        [field]:  value  }));
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    const errorCount = validate(formValues);
    setFormErrors(errorCount);
    if(errorCount.status){
      createProgram(formValues).then(res => handleResponse(res))
    }else{
        window.scrollTo(100, 100);
  return false;
    }
  }

  const handleResponse = (response) => {
    if(response.data.code==400){ 
      const errors = {};
      Swal.fire({
        icon: 'warning',
        title: response.data.message,
        text: response.data.data.ProgammingDate,
      })
      errors.status = false;
      setFormErrors(errors);
    }
    else if(response.data.code==200){ 
      const errors = {};
      Swal.fire({
        icon: 'success',
        title: response.data.message,
        text: 'Event program created successfully',
      }).then(function() {
        window.location = "../programminglist/"+event_id;
    });
      errors.status = false;
      setFormErrors(errors);
    }
  }

  const handleBackSubmit = (e) =>
  {
    window.location = "../programminglist/"+event_id;
  }


  const validate = (values) => {
    // console.log('log 63', values);
    // return false;
    const errors = {};
    errors.status = true;
    // if(!values.fair){
    //     errors.fair = 'Fair is required';
    //     errors.status = false;
    // } 
    if(!values.title){
        errors.title = 'Title is required';
        errors.status = false;
    } 
    if(!values.date){
        errors.date = 'Date is required';
        errors.status = false;
    } 

    if(!values.start_time){
        errors.start_time = 'Start time is required';
        errors.status = false;
    } 

    if(!values.end_time){
      errors.end_time = 'End time is required';
      errors.status = false;
  } 
    
    if(images.length===0){
        errors.images = 'Cover Image is required';
        errors.status = false;
    }

    return errors;
}
  // create programming newcode end
  
return(
<section className="admin-section">
<div className="container">
<div className="row">
<div className="col-md-12 col-12">
<div className="admin-edit">
<h1>Create Programming</h1>
<Form>
<Form.Group>
<Form.Label>Title</Form.Label>
<Form.Control type="text" name="title"   onChange={handleChange} placeholder="Title" />
<p className="error">{formErrors.title}</p>
</Form.Group>
<Row>
<Col md={4}>
<Form.Group controlId="date">
<Form.Label>Date </Form.Label>
<Form.Control
type="date"
name="date"
placeholder="Date"
value={formValues.date}
onChange={(e) => handleChange(e )}
/>
<p className="error">{formErrors.date}</p>
</Form.Group>
</Col>
<Col md={4}>
<Form.Group controlId="starttime">
<Form.Label>Start Time (PST) </Form.Label>
<Form.Control
type="time"
name="start_time"
placeholder="Start time"
value={formValues.startTime}
onChange={(e) => handleChange(e )}
/>
<p className="error">{formErrors.start_time}</p>
</Form.Group>
</Col>
<Col md={4}>
<Form.Group controlId="endtime">
<Form.Label>End Time (PST) </Form.Label>
<Form.Control
type="time"formValues
name="end_time"
placeholder="End time"
value={formValues.endTime}
onChange={(e) => handleChange(e )}
/>
<p className="error">{formErrors.end_time}</p>
</Form.Group>
</Col>
</Row>
<Form.Group>
<Form.Label>Description</Form.Label>
<Form.Control as="textarea" rows="3" name="description" onChange={handleChange}  placeholder="Description" />
</Form.Group>

<Form.Group>
<Form.Label>Zoom Link</Form.Label>
<Form.Control type="text" placeholder="Zoom Link" name="zoom_link" onChange={handleChange} />
</Form.Group>


<Row>
<Col>
<Form.Group>
<Form.Label>Fair</Form.Label> 
<Form.Select aria-label="Default select example" onChange={handleChange} name="fair" disabled>
<option value={event_id}>{localStorage.getItem('program_by_event')}</option>
</Form.Select>
</Form.Group>
</Col>
<Col>
<Form.Group>
<Form.Label>Type</Form.Label>
<Form.Select aria-label="Default select example" onChange={handleChange} name="type">
<option value="">--Select Type--</option>
<option value="Panel discussion">Panel discussion</option>
<option value="Docent tours">Docent tours</option>
<option value="Conversations">Conversations</option>
</Form.Select>
</Form.Group>

</Col>

</Row>
<Form.Group>
<Form.Label>Cover Image</Form.Label>
<p className="error">{formErrors.images}</p>
<ImageUploading
        value={images}
        onChange={onChange}
        maxNumber={maxNumber}
        dataURLKey="data_url"
      >
        {({
          imageList,
          onImageUpload,
          onImageRemoveAll,
          onImageUpdate,
          onImageRemove,
          isDragging,
          dragProps,
        }) => (
          // write your building UI
          <div className="choose-file">
            <button type='button'
              style={isDragging ? { color: 'red' } : undefined}
              onClick={onImageUpload}
              {...dragProps}
            >
           <img src={process.env.PUBLIC_URL+'/images/crop-image.png'}/>
            </button>
 <p>File Specifications: jpg, sRGB, 2MB note: images will be cropped as square</p>
            {imageList.map((image, index) => (
              <div key={index} className="image-item">
                <img src={image['data_url']} alt="" width="100" />
                <div className="image-item__btn-wrapper">
                  {/* <button type='button' onClick={() => onImageUpdate(index)}>Update</button>
                  <button type='button' onClick={() => onImageRemove(index)}>Remove</button> */}
                </div>
              </div>
            ))}
          </div>
        )}
      </ImageUploading>
</Form.Group>
 <br/>
<Button variant="primary" type="button" onClick={handleSubmit} className='common-btn btn btn-secondary'>
Save
</Button>
<Button variant="primary"  onClick={()=> handleBackSubmit()} className='cancel-btn btn btn-primary'>
Cancel
</Button>
</Form>

</div>
</div>
</div>
</div>

</section>

)
}